var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"\n    bg-blue-400\n    px-2\n    py-0.5\n    rounded-lg\n    ml-2\n    text-xs\n    flex flex-col\n    justify-center\n  "},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }